import { Dispatch, SetStateAction } from 'react'
import { QueryType } from 'shared/route-query/types/route-query-interface'
import { PaginationInterface } from 'shared/types/swr-pagination-interface'

export const setPaginationQuery = ({
  limit,
  startFromId,
  order,
  setPagination,
  setLimit,
}: QueryType & {
  setPagination: Dispatch<SetStateAction<PaginationInterface>>
  setLimit: Dispatch<SetStateAction<number>>
}): void => {
  if (order) {
    setPagination(prev => ({ ...prev, order }))
  }

  if (startFromId) {
    setPagination(prev => ({ ...prev, startFromId }))
  }

  if (limit) {
    setLimit(limit)
  }
}
